import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showEnvelopeCoupon,
      expression: "showEnvelopeCoupon"
    }],
    staticClass: "Layer-FullScreen component-envelope-coupon",
    on: {
      "click": function click($event) {
        return _vm.slideDownEnvelopeCoupon();
      }
    }
  }, [_c('div', {
    staticClass: "main-bottom",
    class: {
      'slide-down': _vm.envelopeCouponSlideDown
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("优惠")]), _c('div', {
    staticClass: "main-content"
  }, [_c('p', {
    staticClass: "sub-title"
  }, [_vm._v("当前立享")]), _c('div', {
    staticClass: "envelope-list"
  }, _vm._l(_vm.envelopeList, function (envelope, index) {
    return _c('div', {
      key: index,
      staticClass: "envelope-item"
    }, [_c('div', {
      staticClass: "envelope-title"
    }, [_vm._v("红包")]), _c('div', {
      staticClass: "envelope-text"
    }, [_vm._v(_vm._s(envelope.name))])]);
  }), 0), _c('p', {
    staticClass: "sub-title coupon-title"
  }, [_vm._v("可领取优惠券")]), _c('ul', {
    staticClass: "ycf-couponReceive__list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showType === 2 || _vm.showType === 3,
      expression: "showType === 2 || showType === 3"
    }],
    staticClass: "ycf-couponReceive__emptyTip"
  }, [_c('div', {
    staticClass: "empty_img"
  }), _c('p', {
    staticClass: "empty_text"
  }, [_vm._v("暂无可领取现金券~")])]), _c('h5', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showType === 2,
      expression: "showType === 2"
    }],
    staticClass: "ycf-couponReceive__separate"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("已领取现金券")]), _c('span', {
    staticClass: "subTitle"
  }, [_vm._v("(满足条件后即可用于当前商品)")])]), _vm._l(_vm.couponList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "ycf-couponReceive__coupon"
    }, [_c('div', {
      staticClass: "ycf-couponReceive__couponMain",
      on: {
        "click": function click($event) {
          return _vm.handleReceive(index);
        }
      }
    }, [_c('div', {
      staticClass: "ycf-couponReceive__couponLeft"
    }, [_c('p', {
      staticClass: "offer"
    }, [item.amountType === 'fixed' ? [_c('span', {
      staticClass: "price"
    }, [_vm._v("￥")]), _vm._v(_vm._s(_vm._f("amountFilter")(item.amountAttr.amount)) + "\n                ")] : [_vm._v("\n                  " + _vm._s(_vm._f("discountFilter")(item.amountAttr.discount))), _c('span', {
      staticClass: "discount"
    }, [_vm._v("折")])]], 2), _c('span', {
      staticClass: "condition"
    }, [_vm._v(_vm._s(item.applicableTitle))])]), _c('div', {
      staticClass: "ycf-couponReceive__couponRight"
    }, [_c('h5', {
      staticClass: "right_title"
    }, [item.scopeApp == 1 ? _c('img', {
      staticClass: "right_app",
      attrs: {
        "src": require("./../../assets/img/app-tap.png")
      }
    }) : _vm._e(), _vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "right_content"
    }, [_c('div', {
      staticClass: "right_time"
    }, [_c('p', {
      staticClass: "right_date"
    }, [_vm._v(_vm._s(_vm._f("dateFilter")(item.validDateBegin)) + "-" + _vm._s(_vm._f("dateFilter")(item.validDateEnd)))]), item.hasAssigned === 0 ? _c('div', {
      staticClass: "right_receive"
    }, [_vm._v("领取")]) : _vm._e()]), _c('div', {
      staticClass: "right_intro",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          item.isShowIntro = !item.isShowIntro;
        }
      }
    }, [_c('span', {
      staticClass: "right_text"
    }, [_vm._v("详细说明")]), _c('ycf-image', {
      staticClass: "arrow_img",
      attrs: {
        "src": item.isShowIntro ? '/srcv2/images/arrow_drop-down1.sp@2x.png' : '/srcv2/images/arrow_drop-down.sp@2x.png'
      }
    })], 1)]), item.hasAssigned === 1 ? _c('div', {
      staticClass: "coupon_isReceived"
    }) : _vm._e()])]), _c('Slider', {
      staticClass: "ycf-couponReceive__couponIntro",
      attrs: {
        "is-slide": item.isShowIntro,
        "time": 300
      }
    }, [_c('div', {
      staticClass: "couponIntro"
    }, [item.description && item.description.length > 0 ? _vm._l(item.description, function (text, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(text)), _c('br')]);
    }) : [_c('span', [_vm._v("使用说明：仅购买部分商品可用")])]], 2)])], 1);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.couponList.length > 2,
      expression: "couponList.length > 2"
    }],
    staticClass: "ycf-couponReceive__end"
  }, [_vm._v("已经到底了")])], 2)]), _c('div', {
    staticClass: "main-foot",
    on: {
      "click": function click($event) {
        return _vm.slideDownEnvelopeCoupon();
      }
    }
  }, [_vm._v("关闭")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };